export default __webpack_public_path__ + "static/prohelvetia-ea392afb41b297d031b4827c3a971b17.png";